var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ui-data-table',{attrs:{"headers-on-mobile":"","tableData":_vm.tableData,"tableBodyCustomClass":''}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }